import { CbhFeatureFlag, useCbhFlag } from "src/appV2/FeatureFlags";

/**
 * The Corporate Administrator role is assignable once Spend Controls is launched
 * to customers.
 */
export function useShouldShowCorporateAdminRole(): boolean {
  const spendingControlsConfig = useCbhFlag(CbhFeatureFlag.CONFIGURE_SPENDING_CONTROLS, {
    defaultValue: { enabled: false },
  });

  return spendingControlsConfig.enabled && !spendingControlsConfig.internalUseOnly;
}
